import { IDeleteEntity } from "interfaces/delete-entity";
import { GraphQLData } from "interfaces/graphql-data";
import { ITenant } from "interfaces/tenant";

export class DeleteAppModel implements IDeleteEntity, GraphQLData {
  lastEvaluatedKey: string = '';
  deleted: boolean = false;

  public static create(
    deleted: boolean) : DeleteAppModel {
    const t = new DeleteAppModel();
    t.deleted = deleted;
    return t;
  }

  async hydrate(data: any, tenant: ITenant): Promise<void> {
    //..
    // data.data.GetTenant.Deleted (true)
    console.log(data);
    if (data && data.data && data.data.GetApp && data.data.GetApp.Delete) {
      this.deleted = data.data.GetApp.Delete;
    } else {
      throw new Error('data structured passed in does not contain data, data.data, data.data.GetNode or data.data.GetNode.Delete');
    }
  }
}